module.exports = __webpack_public_path__ + "img/icon-addentries.afaee9dc.svg";